import { render } from "./UserAccessList.vue?vue&type=template&id=f9088612&scoped=true"
import script from "./UserAccessList.vue?vue&type=script&lang=js"
export * from "./UserAccessList.vue?vue&type=script&lang=js"

import "./UserAccessList.vue?vue&type=style&index=0&id=f9088612&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9088612"]])

export default __exports__